import api from '@/assets/plugins/axios'
import {backendUrl, appkey, zjycloud} from '@/assets/js/config'
class AppService {
  tokenLogin (params, headers){
    return api.get(backendUrl + '/token/login', params, headers).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  getRandomKey (params){
    return api.get(backendUrl + '/token/key', params, {'Authorization': appkey}).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  checkCBDToken (params){
    return api.get(zjycloud + '/login/checkGTJtoken.do', params).then(ret => {
      // console.log(ret);
      return ret
    })
  }

  getBanner (params){
    return api.get(backendUrl + '/ysj/banner', params).then(ret => {
      return ret
    })
  }

  getArea (params){
    return api.get(backendUrl + '/common/queryArea', params).then(ret => {
      return ret
    })
  }
  senLog (params){
    return api.post(backendUrl + '/common/log', params).then(ret => {
      return ret
    })
  }

  getHomeBanner (params){
    return api.get(backendUrl + '/ysj/home/banner', params).then(ret => {
      return ret
    })
  }

  getHomeContent (params){
    return api.get(backendUrl + '/ysj/home/content', params).then(ret => {
      return ret
    })
  }
}

export default new AppService()
